import axios from '@/axios';

const RESOURCE_NAME = '/admin/markets/sub-sectors';

export default {
    getIndexList(data) {
        return axios.post(`${RESOURCE_NAME}/get-index-list`, data)
    },

    getEdit(id) {
        return axios.get(`${RESOURCE_NAME}/get-edit?id=${id}`)
    },

    save(id, data) {
        return axios.post(`${RESOURCE_NAME}/save?id=${id}`, data)
    },

    getList() {
        return axios.get(`${RESOURCE_NAME}/get-list`)
    },

    getData(id) {
        return axios.get(`${RESOURCE_NAME}/get-data?id=${id}`)
    },

    getFocusAreas(id) {
        return axios.get(`${RESOURCE_NAME}/get-focus-areas?id=${id}`)
    },

    resyncFocusAreas(id) {
        return axios.post(`${RESOURCE_NAME}/resync-focus-areas?id=${id}`)
    },

    delete(id) {
        return axios.post(`${RESOURCE_NAME}/delete-sub-sector?id=${id}`)
    },

    populatePartnerships(id, model) {
        return axios.post(`${RESOURCE_NAME}/populate-partnerships?id=${id}&model=${model}`);
    },
}
